export default class SettingsTab {
    constructor(obj) {
        this.icon = obj.icon;
        this.title = obj.title;
        this.content = obj.content;
    }

    getContentByType(type) {
        if (this.content) {
            return this.content[type] || this.content.default || [];
        } else {
            return [];
        }
    }
}
